<template>
    <div class="test-service-online-delegation">
        <a-breadcrumb separator=">">
            <template v-if="isCigarette">
                <a-breadcrumb-item>
                    <router-link to="/cigarette">
                        <img src="../../assets/cigarette/电子烟专区-蓝.svg" style="margin: 0 4px 4px 0" />
                        电子烟专区
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <template v-else>
                <a-breadcrumb-item>
                    <router-link to="/test-service">
                        <img src="../../assets/test-service/service.svg" style="margin: 0 4px 4px 0" />
                        检测服务
                    </router-link>
                </a-breadcrumb-item>
            </template>
            <a-breadcrumb-item>在线委托</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="flow">
            <a-steps :current="current" labelPlacement="vertical">
                <a-step v-for="item in steps" :key="item.title" :title="item.title" />
            </a-steps>

            <template v-if="current === 0">
                <custom-form
                    ref="info-form"
                    :panels="panelFields"
                    :hideFields="hideFields"
                    style="margin-bottom: 26px"
                    :fieldsValue="entrustInfo"
                    layout="vertical"
                    @change="changeHandle"
                ></custom-form>
                <div class="button-contain">
                    <a-button @click="cancel"> 取消 </a-button>
                    <a-button type="primary" @click="handleInfo" :loading="loading"> 下一步 </a-button>
                </div>
            </template>
            <template v-if="current === 1">
                <div class="test-project">
                    <div class="label">请选择检测项目类型</div>
                    <a-checkbox-group v-model="checkedProj" style="width: 100%">
                        <a-row :gutter="[32, 8]" v-for="(st, index) of groupSelectTests" :key="index">
                            <a-col :span="6" v-for="test of st" :key="test.id">
                                <a-checkbox :value="test"> {{ test.testName }}</a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div class="count">已检测项目({{ checkedProj.length }})</div>
                </div>
                <div class="button-contain">
                    <a-button @click="backEntrust"> 上一步 </a-button>
                    <a-button type="primary" @click="insertOrderType" :loading="loading"> 下一步 </a-button>
                </div>
            </template>

            <template v-if="current === 2">
                <div class="title">样品列表</div>
                <div class="toolbar">
                    <a-button type="primary" @click="addSample" :loading="loading">添加</a-button>
                    <a-button @click="handleDeleteSample">删除</a-button>
                    <a-button @click="downloadTemplate">模板下载</a-button>
                    <a-upload :multiple="false" :showUploadList="false" accept=".xls" :customRequest="handleFileChange">
                        <a-button @click="clickUpload(record.id)">导入</a-button>
                    </a-upload>
                </div>
                <a-table
                    :columns="columns"
                    :data-source="sampleData.rows"
                    rowKey="id"
                    :scroll="{ y: 320, x: 1000 }"
                    :row-selection="rowSelection"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                >
                    <template #sampleCountUnit="record">
                        <div>{{ getUnitName(record.sampleCountUnit) }}</div>
                    </template>

                    <template #productioncompanyname="record">
                        <div>{{ record.ext$.productioncompanyname }}</div>
                    </template>

                    <template #action="record">
                        <a style="display: block" @click="sampleDetail(record)">修改</a>
                        <a style="display: block">物流信息</a>
                    </template>
                </a-table>

                <div class="button-contain">
                    <a-button @click="prevStep"> 上一步 </a-button>
                    <a-button type="primary" @click="submit" :loading="loading"> 提交委托 </a-button>
                </div>

                <a-modal
                    :visible="visible"
                    destroyOnClose
                    title="添加样品"
                    class="add-sample"
                    width="80%"
                    :dialogStyle="{
                        height: '80%'
                    }"
                    @cancel="handleCancel"
                >
                    <custom-form
                        ref="add-form"
                        :panels="sampleFields"
                        :hideFields="selectOrderHideFields"
                        :fieldsValue="sampleInfo"
                        layout="vertical"
                    ></custom-form>
                    <custom-form
                        ref="other-form"
                        :fieldsValue="otherInfo"
                        :panels="otherFields"
                        layout="vertical"
                    ></custom-form>

                    <template #footer>
                        <a-button v-if="showFooterToolbar" @click="handleCancel"> 取消 </a-button>
                        <a-button v-if="showFooterToolbar" type="primary" @click="handleOk"> 确定 </a-button>
                    </template>
                </a-modal>
            </template>
            <template v-if="current === 3">
                <div class="result">
                    <img src="../../assets/test-service/成功.svg" style="margin-bottom: 8px" />
                    <span style="margin-bottom: 24px; font-size: 22px; font-weight: 600">提交成功</span>
                    <div style="font-size: 16px; color: #1890ff" @click="viewDetail">查看详情</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import customForm from '../../components/custom-form.vue';
import { deleteTestServiceTable, upload, uploadSample } from '../../common/api';
// import { uuid } from '../../common/utils';

export default {
    components: { customForm },
    data() {
        return {
            loading: false,
            params: {
                type: 'detail',
                systemType: 'LIMS',
                orderCodeFlag: 'draft',
                viewTaskBtn: '1',
                pushToLimsFlag: '0',
                folderId: ''
            },
            checkedProj: [],
            current: 0,
            currentPage: 1,
            pageSize: 10,
            steps: [{ title: '委托信息' }, { title: '检测项目' }, { title: '样品信息' }, { title: '结果' }],
            sampleType: '',
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => index + 1
                },
                // { title: '样品', dataIndex: 'id', align: 'center' },
                // { title: '样品编号', dataIndex: 'orderCode', align: 'center' },
                { title: '样品名称', dataIndex: 'mtlName', align: 'center' },
                { title: '样品数量', dataIndex: 'sampleCount', align: 'center' },
                {
                    title: '单位',
                    key: 'sampleCountUnit',
                    align: 'center',
                    scopedSlots: { customRender: 'sampleCountUnit' }
                },
                {
                    title: '生产企业',
                    key: 'productioncompanyname',
                    align: 'center',
                    scopedSlots: { customRender: 'productioncompanyname' }
                },
                { title: '其他技术指标或原编号', dataIndex: 'originalNumber', align: 'center' },
                { title: '备注信息', dataIndex: 'remark', align: 'center' },
                // { title: '样品状态', dataIndex: 'status', align: 'center' },
                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ],
            visible: false,
            selectedRowKeys: [],
            showFooterToolbar: true,
            entrustInfo: {}, //委托信息
            sampleInfo: {}, //样品信息
            otherInfo: {} //其他参数信息
        };
    },

    watch: {
        current: {
            immediate: true,
            handler(c) {
                switch (c) {
                    case 0:
                        this.getOrderFormData(this.$route.query.folderId);
                        break;
                    case 1:
                        // this.getOrderFormData(this.params.folderId);
                        break;
                    case 2:
                        this.getSampleData({
                            folderId: this.params.folderId,
                            f: { longRangeStandard_DIFFER: '1' },
                            n: this.currentPage,
                            s: this.pageSize,
                            qf: {},
                            o: [{ orderNo: 'desc' }]
                        });
                        break;
                    default:
                        break;
                }
            }
        },

        originSampleType: {
            immediate: true,
            handler() {
                this.setSampleType(this.isCigarette);
            }
        }
    },

    async mounted() {
        await this.getOrderFormData(this.$route.query.folderId);
        this.entrustInfo = { ...this.orderFormData };

        if (this.entrustInfo.sampleType) {
            this.getSampleUnit(this.entrustInfo.sampleType);
        }
    },

    computed: {
        ...mapState('testService', [
            'hideFields',
            'orderFormData',
            'selectTests',
            'sampleData',
            'virtualId',
            'selectOrderHideFields',
            'folderTask'
        ]),
        ...mapState('testService', { unitSelect: state => state.sampleType }),
        ...mapGetters('testService', ['panelFields', 'sampleFields', 'otherFields']),
        ...mapState(['originSampleType']),

        pagination() {
            return {
                total: this.sampleData.total ?? 0,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: this.pageSize,
                showTotal(total) {
                    return `总共${total}条`;
                },
                current: this.currentPage
            };
        },

        dateFields() {
            const arr = [];
            this.panelFields.forEach(panel => {
                const fields = panel.fieldGroup[0];
                const df = fields.filter(f => f.type === 'date');
                arr.concat(df);
            });
            return arr;
        },

        groupSelectTests() {
            const selectTests = this.selectTests;
            return this.chunkArray(selectTests, 4);
        },

        isCigarette() {
            return this.$route.meta.isCigarette;
        },

        rowSelection() {
            return {
                onChange: selectedRowKeys => {
                    this.selectedRowKeys = selectedRowKeys;
                }
            };
        }
    },

    methods: {
        ...mapActions('testService', [
            'getOrderFormData',
            'getSelectTests',
            'getOrderTemp',
            'insertOrderTask',
            'getSampleData',
            'getNextIdentity',
            'getQSampleType',
            'insertOrderLims',
            'saveOrderFormData',
            'getSelectParameterFields',
            'submitToLims',
            'getSelectOrderHideFields',
            'getFolderTask',
            'getPositionSelect'
        ]),
        ...mapActions(['getSampleUnit']),

        ...mapMutations(['changeSpinning', 'setSampleType']),

        cancel() {
            this.$router.push({ name: this.isCigarette ? 'cigarette-entrust' : 'test-service' });
        },

        getUnitName(val) {
            if (val) {
                const data = this.unitSelect.find(item => item.value === val);
                if (data.label) {
                    return data.label;
                } else {
                    return val;
                }
            }
        },

        viewDetail() {
            this.$router.push({ name: 'test-service' });
        },

        handleInfo() {
            const form = this.$refs['info-form'].form;
            form.validateFields(async (err, values) => {
                if (!err) {
                    this.entrustInfo = values;
                    this.loading = true;
                    const orderFormData = { ...this.orderFormData, ...values };
                    this.sampleType = orderFormData.sampleType;
                    const orderTmplId = (
                        await this.getOrderTemp({
                            f: {
                                sampleTypeCode_SEQ: orderFormData.sampleType,
                                folderId: this.params.folderId,
                                defaultProcess_SEQ: '1'
                            },
                            n: -1
                        })
                    ).data.rows[0]?.id;
                    if (!orderTmplId) {
                        this.loading = false;
                        return this.$message.warning('该样品类型无默认流程模板');
                    }

                    await this.saveOrderFormData(orderFormData);
                    await this.getSelectTests({
                        f: { orderTmplId, enable_SEQ: '1' },
                        n: -1,
                        o: [{ 'ext$.itemclassificationid': 'asc' }, { itemclassificationname: 'asc' }]
                    });
                    this.loading = false;

                    //查询检测项目
                    await this.getFolderTask(this.params.folderId);
                    this.checkedProj = this.selectTests.filter(s => {
                        return this.folderTask.map(f => f.testId).includes(s.id.toString());
                    });
                    //下一步
                    this.nextStep();
                } else {
                    this.$warning({
                        title: '校验失败',
                        content: '请检查是否存在检验失败的字段'
                    });
                }
            });
        },

        async insertOrderType() {
            this.loading = true;
            const checkedProj = this.checkedProj;
            const chooseData = checkedProj.map(item => {
                return {
                    testId: item.id,
                    testName: item.testName,
                    testMethodId: item.ext$.testmethodid,
                    postId: item.ext$.postid,
                    projectTemplateGroupId: item.ext$.projecttemplategroupid,
                    postName: item.ext$.postname,
                    methodCodes: item.ext$.methodcodes,
                    itemClassificationId: item.ext$.itemclassificationid,
                    classficationFullName: item.ext$.itemclassificationname,
                    cost: item.cost,
                    ext$: {
                        testmethodpostid: item.ext$.testmethodpostid,
                        projectapproval: item.projectApproval,
                        postnames: item.ext$.postnames
                    },
                    folderId: this.params.folderId
                };
            });

            await this.insertOrderTask(chooseData);
            //单位下拉参数
            await this.getQSampleType({ f: { SCATEGORYCODE_SEQ: this.sampleType } });
            this.loading = false;
            this.nextStep();
        },

        nextStep() {
            this.current++;
        },

        prevStep() {
            this.current--;
        },

        backEntrust() {
            this.current--;
            setTimeout(() => {
                this.$refs['info-form'].form.setFieldsValue(this.entrustInfo);
            }, 0);
        },

        chunkArray(arr, chunkSize) {
            const chunkedArray = [];
            for (let i = 0; i < arr.length; i += chunkSize) {
                chunkedArray.push(arr.slice(i, i + chunkSize));
            }
            return chunkedArray;
        },

        async handleTableChange(pagination) {
            this.currentPage = pagination.current;
            this.pageSize = pagination.pageSize;
            this.loading = true;
            await this.getSampleData({
                f: { longRangeStandard_DIFFER: '1' },
                n: this.currentPage,
                s: this.pageSize,
                qf: {},
                o: [{ orderNo: 'desc' }]
            });
            this.loading = false;
        },

        async addSample() {
            await this.getSelectOrderHideFields();
            this.changeSpinning(true);
            this.loading = true;
            await this.getNextIdentity();
            await this.getOrderFormData(this.params.folderId);
            const orderFormInfo = this.orderFormData;
            this.params.contractCode = orderFormInfo.ext$.contractcode;
            this.params.sampleType = this.sampleType;
            this.params.orderDesc = orderFormInfo.sealingSampleStatus;
            this.params.ordersources = orderFormInfo.samplingWay;
            this.params.otherCategories = orderFormInfo.otherCategories;
            this.params.samplingUnitName = orderFormInfo.samplingUnitName;
            this.params.sampledate = orderFormInfo.samplingTime;
            this.params.samplingnumber = orderFormInfo.samplingBase;
            this.params.samplingpurpose = orderFormInfo.samplingBasis;
            this.params.sampleaddress = orderFormInfo.sampleLocation;
            this.params.sampler = orderFormInfo.samplingPerson;
            this.params.sender = orderFormInfo.sampler;
            this.params.reportSignature = orderFormInfo.reportSignature;
            this.params.testCategory = orderFormInfo.testCategory;
            await this.getSelectParameterFields(this.sampleType);
            this.visible = true;
            this.changeSpinning(false);
            this.loading = false;

            setTimeout(() => {
                this.sampleInfo = {
                    orderDesc: this.entrustInfo.sealingSampleStatus,
                    ext$: {
                        sender: this.entrustInfo.sampler,
                        samplingunitname: this.entrustInfo.samplingUnitName,
                        sampledate: this.entrustInfo.samplingTime,
                        samplingpurpose: this.entrustInfo.samplingBasis,
                        sampleaddress: this.entrustInfo.sampleLocation,
                        sampler: this.entrustInfo.samplingPerson
                    },
                    sampleCount: this.entrustInfo.sampleCount,
                    sampleCountUnit: this.entrustInfo.sampleUnit
                };
            }, 0);
        },

        //删除样品列表
        async handleDeleteSample() {
            const ids = this.selectedRowKeys.map(item => {
                return { id: item };
            });
            await deleteTestServiceTable(this.params.folderId, ids);
            this.$message.success('删除成功');
            this.getSampleData({
                folderId: this.params.folderId,
                f: { longRangeStandard_DIFFER: '1' },
                n: this.currentPage,
                s: this.pageSize,
                qf: {},
                o: [{ orderNo: 'desc' }]
            });
        },

        async sampleDetail(val) {
            await this.getSelectOrderHideFields();
            this.changeSpinning(true);
            this.loading = true;
            await this.getNextIdentity();
            await this.getOrderFormData(this.params.folderId);
            const orderFormInfo = this.orderFormData;
            this.params.contractCode = orderFormInfo.ext$.contractcode;
            this.params.sampleType = this.sampleType;
            this.params.orderDesc = orderFormInfo.sealingSampleStatus;
            this.params.ordersources = orderFormInfo.samplingWay;
            this.params.otherCategories = orderFormInfo.otherCategories;
            this.params.samplingUnitName = orderFormInfo.samplingUnitName;
            this.params.sampledate = orderFormInfo.samplingTime;
            this.params.samplingnumber = orderFormInfo.samplingBase;
            this.params.samplingpurpose = orderFormInfo.samplingBasis;
            this.params.sampleaddress = orderFormInfo.sampleLocation;
            this.params.sampler = orderFormInfo.samplingPerson;
            this.params.sender = orderFormInfo.sampler;
            this.params.reportSignature = orderFormInfo.reportSignature;
            this.params.testCategory = orderFormInfo.testCategory;
            await this.getSelectParameterFields(this.sampleType);
            this.visible = true;
            this.changeSpinning(false);
            this.loading = false;

            setTimeout(() => {
                this.sampleInfo = { ...val };
                this.otherInfo = { ...val.ext$ };
            }, 0);
        },

        //模板下载
        async downloadTemplate() {
            // const res =  exportTemplate(
            //     this.params.folderId,
            //     this.entrustInfo.sampleType,
            //     this.orderFormData.testCategory
            // );
            // this.downLoad(res.data);
            window.open(
                `/yc/secure/css/module/online-orders/download-cims-template/ExportTemplate?id=${this.params.folderId}&sampleType=${this.entrustInfo.sampleType}&testCategory=${this.orderFormData.testCategory}`
            );
        },

        downLoad(res) {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); //type为所需要下载的文件格式，以xlsx文件为例
            const url = window.URL.createObjectURL(blob);
            const fileName = '模板';
            if ('download' in document.createElement('a')) {
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            } else {
                navigator.msSaveBlob(blob, fileName);
            }
        },

        async handleFileChange({ file }) {
            const { data } = await upload({
                name: file.name,
                file,
                targetId: `T_LIMS_ORDER$${this.params.folderId}`
            });
            if (data) {
                await uploadSample(data);
                this.getSampleData({
                    folderId: this.params.folderId,
                    f: { longRangeStandard_DIFFER: '1' },
                    n: this.currentPage,
                    s: this.pageSize,
                    qf: {},
                    o: [{ orderNo: 'desc' }]
                });
                this.$message.success('上传成功！');
            }
        },

        handleOk() {
            this.changeSpinning(true);
            const form = this.$refs['add-form'].form;
            const otherForm = this.$refs['other-form'].form;
            form.validateFields(async (err, values) => {
                if (!err) {
                    const p = {
                        p: {
                            type:
                                this.params.long_range_flag === 'long_range_flag'
                                    ? this.params.long_range_flag
                                    : 'limsOrdersAdd',
                            province: this.params.province,
                            industrytaskOrderId: this.params.industrytaskOrderId,
                            virtualId: this.virtualId,
                            addFrom: this.params.addFrom,
                            modify: this.params.modify
                        },
                        b: [
                            'limsOrderServiceImpl',
                            [
                                {
                                    folderId: this.params.folderId,
                                    ...values,
                                    ...(this.sampleInfo.id ? { id: this.sampleInfo.id } : {})
                                }
                            ]
                        ],
                        b1: ['limsOrdersParamServiceImpl', [otherForm.getFieldsValue()]]
                    };
                    await this.insertOrderLims(p);

                    this.getSampleData({
                        folderId: this.params.folderId,
                        f: { longRangeStandard_DIFFER: '1' },
                        n: this.currentPage,
                        s: this.pageSize,
                        qf: {},
                        o: [{ orderNo: 'desc' }]
                    });
                    this.visible = false;
                } else {
                    this.$warning({
                        title: '校验失败',
                        content: '请检查是否存在检验失败的字段'
                    });
                }

                this.changeSpinning(false);
            });
        },

        handleCancel() {
            this.visible = false;
        },

        async submit() {
            this.loading = true;
            const { folderId, systemType } = this.params;
            await this.submitToLims({
                b: ['', [{ id: folderId, systemType, ext$: { sampletype: this.sampleType } }]]
            });

            this.loading = false;

            this.nextStep();
        },

        changeHandle(...args) {
            if (args[0] === 'sampleType') {
                this.getSampleUnit(args[1]);
                this.$refs['info-form'].form.setFieldsValue({
                    sampleUnit: undefined
                });
            }
        }
    },

    created() {
        const folderId = this.$route.query.folderId;
        if (folderId) {
            this.$set(this.params, 'folderId', folderId);
        }
        this.setSampleType(this.isCigarette);
        this.getPositionSelect();
    }
};
</script>

<style lang="scss" scoped>
.test-service-online-delegation {
    width: 1200px;

    ::v-deep {
        .ant-form {
            .panel {
                margin-bottom: 16px;
                .rows {
                    padding: 16px 16px 0 16px;
                    border: 1px solid rgba(235, 235, 235, 1);
                }
            }

            .ant-form-item-label {
                line-height: 25px;
            }
        }
    }

    .flow {
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        min-height: 500px;

        .ant-steps {
            width: 750px;
            margin: 8px 0 40px 0;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }

        .button-contain {
            display: flex;
            align-items: center;
            justify-content: center;
            .ant-btn {
                width: 200px;
                height: 44px;
                margin: 8px;
            }
        }

        .test-project {
            width: 728px;
            background: rgba(222, 233, 244, 0.2);
            border-radius: 2px;
            padding: 16px 24px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);

            .label {
                width: 100%;
                height: 32px;
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 600;
            }

            .count {
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 600;
                border-top: 1px solid #eee;
                padding-top: 8px;
            }
        }

        ::v-deep {
            .ant-checkbox-group {
                .ant-checkbox-wrapper {
                    display: flex;

                    .ant-checkbox {
                        position: relative;
                        top: 3px;

                        &.ant-checkbox-checked:hover {
                            height: 16px;
                        }
                    }
                }
            }
        }

        .title {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: left;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 600;
        }

        .toolbar {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .ant-btn {
                margin: 0 4px;
            }
        }

        .result {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
::v-deep.add-sample {
    .ant-modal {
        color: red;
        .ant-modal-content {
            display: flex;
            flex-direction: column;
            height: 100%;
            .ant-modal-body {
                flex: 1;
                overflow-y: auto;
            }
        }
    }
}
</style>
